import { ApolloCache, NormalizedCacheObject } from '@apollo/client'
import { IS_EMBEDDED } from '@sketch/constants'

import {
  GetBrowserSettingsDocument,
  GetBrowserSettingsQuery,
  GetDocumentListSettingsDocument,
  GetDocumentListSettingsQuery,
} from '@sketch/gql-types'

export const initializeLocalApolloState = (
  cache: ApolloCache<NormalizedCacheObject>
) => {
  // Initialize the DocumentLayout grid setting on cache
  cache.writeQuery<GetDocumentListSettingsQuery>({
    query: GetDocumentListSettingsDocument,
    data: {
      __typename: 'RootQueryType',
      documentsLayout: 'GRID',
      showDocumentsInProjects: true,
      showArchivedDocuments: false,
    },
  })

  // Initialize user settings on cache
  cache.writeQuery<GetBrowserSettingsQuery>({
    query: GetBrowserSettingsDocument,
    data: {
      __typename: 'RootQueryType',
      sidebarRightOpen: !IS_EMBEDDED,
    },
  })
}
